const setupForFlashDeals = (sponsor, team) => {

  // For now, only checking sponsor, but in the future, we might check the team, so we'll keep
  // the 'team' argument in the function call
  return (sponsor.stripeAccountId !== undefined);
}

export {
  setupForFlashDeals,
};